import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react-pro";
import { useCartStore, type StrategyCartItem } from "../../../state/cartStore";
import { useToast } from "../../../context/useToast";

interface CartHoldsUpgradeDialogProps {
  /** The strategy she tried to add, or null when the question isn't being asked. */
  item: StrategyCartItem | null;
  onClose: () => void;
}

/**
 * Asked when Add to cart is pressed while an upgrade or an extension is in the cart, either of which is
 * checked out on its own.
 */
export function CartHoldsUpgradeDialog({ item, onClose }: CartHoldsUpgradeDialogProps) {
  const upgrade = useCartStore((s) => s.upgrade);
  const extension = useCartStore((s) => s.extension);
  const removeUpgrade = useCartStore((s) => s.removeUpgrade);
  const removeExtension = useCartStore((s) => s.removeExtension);
  const addStrategy = useCartStore((s) => s.addStrategy);
  const { showSuccess } = useToast();

  const emptyAndAdd = () => {
    if (item === null) {
      return;
    }

    removeUpgrade();
    removeExtension();
    addStrategy(item);
    showSuccess(`${item.name} added to cart.`);
    onClose();
  };

  return (
    <CModal visible={item !== null} onClose={onClose} alignment="center">
      <CModalHeader>
        <CModalTitle>Add {item?.name} to your cart?</CModalTitle>
      </CModalHeader>
      <CModalBody>
        {extension !== null ? (
          <p className="mb-0">
            Your cart has <strong>the extension of {extension.name}</strong> in it.
            An extension is checked out by itself, so you can do it after.
          </p>
        ) : (
          <p className="mb-0">
            Your cart has <strong>the upgrade of {upgrade?.name}</strong> in it. An
            upgrade is checked out by itself, so you can do it after.
          </p>
        )}
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" variant="outline" onClick={onClose}>
          Keep my cart
        </CButton>
        <CButton color="primary" onClick={emptyAndAdd}>
          Empty cart and add
        </CButton>
      </CModalFooter>
    </CModal>
  );
}
